<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <b-card class="mt-0">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-row>
                            <b-col>
                                Cấu hình giao diện Form hiển thị biến động
                            </b-col>
                        </b-row>
                    </b-card-header>
                    <b-card-body>
                        <b-form @submit.prevent="loadAssetMutationSample">
                            <b-row>
                                <b-col offset-md="3">
                                    <b-form-group label="Nhóm tài sản:"
                                                  label-cols-md="2"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <treeselect v-model="assetTypeGroupId"
                                                    class="no-padding col-md-6"
                                                    :defaultExpandLevel="1"
                                                    :always-open="false"
                                                    :append-to-body="true"
                                                    :max-height="390"
                                                    placeholder="Nhập tên nhóm tài sản"
                                                    :options="assetTypeGroups" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col offset-md="3">
                                    <b-form-group label="Loại biến động:"
                                                  label-cols-md="2"
                                                  :horizontal="true"
                                                  label-align="left">
                                        <div class="col-md-6 no-padding">
                                            <select2 v-model="assetMutationTypeId" :options="assetMutationTypes" style="width:100%"></select2>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col offset-md="3">
                                    <b-form-group label="" :label-cols="4" label-cols-md="2">
                                        <b-button type="submit" variant="primary">Xem</b-button>
                                        <b-button type="button" variant="success" @click="saveMappings">Cập nhật <span style="color: red" v-if="dirty">(*)</span></b-button>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <br />
        <b-row v-if="assetMutation.id">
            <b-col>
                <b-button class="pull-right" variant="primary" @click="addNewField">Thêm trường</b-button>
                <b-button class="pull-right" @click="addNewGroup">Thêm nhóm</b-button>
            </b-col>
        </b-row>
        <br />
        <b-row class="document-view" style="border: 1px solid red" v-if="assetMutation.id">
            <b-col lg="12">
                <b-row style="margin: 0">
                    <template v-for="(group, index) in customFieldGroups">
                        <b-card :class="`col-md-${group.ref.displayGridColumn}`">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-row>
                                    <b-col>
                                        <b-link v-b-toggle="'accordion-group-' + group.ref.text">
                                            <span :id="`group_${group.ref.id}`">
                                                {{ group.ref.text }}
                                            </span>
                                            <b-popover :title="`Nhóm ${group.ref.text}`" :target="`group_${group.ref.id}`"
                                                       triggers="hover"
                                                       placement="topright"
                                                       :delay="{ show: 500, hide: 200 }">
                                                <b-button-group>
                                                    <b-button size="sm" class="mr-1" variant="primary" title="Sửa" @click="editGroup(group)"><i class="fa fa-edit" aria-hidden="true"></i></b-button>
                                                    <b-button size="sm" class="mr-1" variant="danger" title="Xóa" @click="removeGroup(group)"><i class="fa fa-remove" aria-hidden="true"></i></b-button>
                                                    <b-button size="sm" class="mr-1" variant="success" title="Chuyển lên trên" @click="swapGroup(group, customFieldGroups[index -1])" v-if="index > 0"><i class="fa fa-arrow-up" aria-hidden="true"></i></b-button>
                                                    <b-button size="sm" class="mr-1" variant="success" title="Chuyển xuống dưới" @click="swapGroup(group, customFieldGroups[index +1])" v-if="index < customFieldGroups.length - 1 && index < assetMutation.customGroups.length - 1"><i class="fa fa-arrow-down" aria-hidden="true"></i></b-button>
                                                </b-button-group>
                                                <div>
                                                    <b-form-group label="Displayed:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-checkbox v-model="group.fields.map(x => x.isDisplayed).reduce((a,b) => a && b)" @change="(checked) => displayGroup(checked, group)" title="Được hiển thị trên form tài sản"></b-form-checkbox>
                                                    </b-form-group>
                                                </div>
                                            </b-popover>
                                            <span class="when-opened pull-right">
                                                <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                            </span>
                                            <span class="when-closed pull-right">
                                                <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                            </span>
                                        </b-link>
                                    </b-col>
                                </b-row>
                            </b-card-header>

                            <b-collapse :id="'accordion-group-' + group.ref.text" visible role="tabpanel">
                                <b-card-body>
                                    <b-row>
                                        <template v-for="(field, index) in group.fields">
                                            <div class="col-12" v-if="field.displayNewLine"></div>
                                            <b-col :md="field.displayGridColumn" :id="`field_${field.id}`" class="editable">
                                                <b-form-group :label="getFieldLabel(field)"
                                                              :label-cols="field.displayLabelColumn"
                                                              :label-class="getLabelClass(field)"
                                                              :title="getFieldTitle(field)"
                                                              :horizontal="true"
                                                              label-align="left">
                                                    <b-form-input :value="getFieldValue(field)" :title="getFieldValue(field)" :readonly="true" v-if="field.name"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <template v-if="field.name == null && field.displayName.toLocaleLowerCase().indexOf('hien trang') != -1">
                                                <b-col md="2" v-for="usage in assetMutation.usageStates" :key="usage.id">
                                                    <b-form-group :label="usage.name"
                                                                  :title="usage.name"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-input v-if="usage.isAreaUsage" :value="usage.value | formatNumber" :title="usage.value | formatNumber" :readonly="true"></b-form-input>
                                                        <b-checkbox disabled v-else v-model="usage.value >= 1"></b-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                            </template>
                                            <b-popover :target="`field_${field.id}`" triggers="hover" placement="topright" :delay="{ show: 500, hide: 200 }">
                                                <template v-slot:title>
                                                    <div style="width: 130px" :title="field.name">
                                                        {{ getFieldLabel(field) }}
                                                    </div>
                                                </template>
                                                <b-button-group>
                                                    <b-button size="sm" class="mr-1" variant="info" title="Thêm field phía trước" @click="addNewField(field, 0)"><i class="fa fa-share-square fa-flip-horizontal" aria-hidden="true"></i></b-button>
                                                    <b-button size="sm" class="mr-1" variant="success" title="Chuyển lên phía trước" @click="swap(field, group.fields[index -1])" v-if="index > 0"><i class="fa fa-arrow-up" aria-hidden="true"></i></b-button>
                                                    <b-button size="sm" class="mr-1" variant="primary" title="Sửa" @click="edit(field)"><i class="fa fa-edit" aria-hidden="true"></i></b-button>
                                                    <b-button size="sm" class="mr-1" variant="danger" title="Xóa" @click="remove(field)"><i class="fa fa-remove" aria-hidden="true"></i></b-button>
                                                    <b-button size="sm" class="mr-1" variant="success" title="Chuyển xuống phía sau" @click="swap(field, group.fields[index +1])" v-if="index < group.fields.length - 1"><i class="fa fa-arrow-down" aria-hidden="true"></i></b-button>
                                                    <b-button size="sm" class="mr-1" variant="info" title="Thêm field phía sau" @click="addNewField(field, 1)"><i class="fa fa-share-square" aria-hidden="true"></i></b-button>
                                                </b-button-group>
                                                <div>
                                                    <b-form-group label="New Line:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-checkbox v-model="field.displayNewLine" title="Hiển thị ở dòng mới"></b-form-checkbox>
                                                    </b-form-group>
                                                    <b-form-group label="Grid:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-select v-model="field.displayGridColumn" :options="gridColumnOptions"></b-form-select><br />
                                                    </b-form-group>
                                                    <b-form-group label="Label:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-select v-model="field.displayLabelColumn" :options="gridColumnOptions"></b-form-select>
                                                    </b-form-group>
                                                    <b-form-group label="Bold:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-checkbox v-model="field.displayLabelBold" title="In đậm label"></b-form-checkbox>
                                                    </b-form-group>
                                                    <b-form-group label="Italic:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-checkbox v-model="field.displayLabelItalic" title="In nghiêng label"></b-form-checkbox>
                                                    </b-form-group>
                                                    <b-form-group label="Hide Label:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-checkbox v-model="field.displayLabelNone" title="Không hiển thị label"></b-form-checkbox>
                                                    </b-form-group>
                                                    <b-form-group label="Displayed:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-checkbox v-model="field.isDisplayed" title="Được hiển thị trên form tài sản"></b-form-checkbox>
                                                    </b-form-group>
                                                    <b-form-group label="Required:"
                                                                  label-cols="6"
                                                                  :horizontal="true"
                                                                  label-align="left">
                                                        <b-form-checkbox v-model="field.isRequired" title="Bắt buộc"></b-form-checkbox>
                                                    </b-form-group>
                                                </div>
                                            </b-popover>
                                        </template>
                                    </b-row>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </template>
                </b-row>
            </b-col>
        </b-row>


        <b-modal :no-enforce-focus="true" id="group-add-new-modal" ref="groupAddNewModal" size="md" title="Thêm nhóm mới" @ok="saveNewGroup">
            <b-row>
                <b-col>
                    <b-form-group label="Tên hiển thị:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-input v-model="newGroupName" lazy></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Độ rộng grid:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-select v-model="newGroupGridColumn" :options="gridColumnOptions"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal :no-enforce-focus="true" id="group-edit-modal" ref="groupEditModal" size="md" :title="`Cập nhật nhóm ${selectedGroupName}`" @ok="saveEditedGroup">
            <template v-if="selectedGroup.id">
                <b-row>
                    <b-col>
                        <b-form-group label="Tên hiển thị:"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="right">
                            <b-form-input v-model="selectedGroupName" lazy></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group label="Độ rộng grid:"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="right">
                            <b-form-select v-model="selectedGroupGridColumn" :options="gridColumnOptions"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <template v-else>
                <b-row>
                    <b-col>
                        <b-form-group label="Chọn nhóm:"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="right">
                            <select2 v-model="selectedGroupNewGroupId" :options="assetMutation.customGroups"></select2>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
        </b-modal>

        <b-modal :no-enforce-focus="true" id="field-new-modal" ref="fieldEditModal" size="lg" :title="'Cập nhật trường ' + selectedField.name" @ok="save">
            <b-row>
                <b-col>
                    <b-form-group label="Tên trường dữ liệu:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <label class="col-form-label">{{ selectedField.name }}</label>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Tên hiển thị:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-input v-model="selectedField.displayName" lazy></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Định dạng hiển thị:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-input v-model="selectedField.displayFormat" lazy></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Nhóm:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <select2 v-model="selectedField.groupId" :options="assetMutation.customGroups"></select2>
                        <!--<b-form-input v-model="selectedField.group" lazy></b-form-input>-->
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Hiển thị trên dòng mới:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="selectedField.displayNewLine"></b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Độ rộng grid:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-select v-model="selectedField.displayGridColumn" :options="gridColumnOptions"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Độ rộng label:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-select v-model="selectedField.displayLabelColumn" :options="gridColumnOptions"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="In đậm label:"
                                  :label-cols="8"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="selectedField.displayLabelBold"></b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="In nghiêng label:"
                                  :label-cols="8"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="selectedField.displayLabelItalic"></b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Không hiển thị label:"
                                  :label-cols="8"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="selectedField.displayLabelNone"></b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Hiển thị trên form tài sản:"
                                  :label-cols="8"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="selectedField.isDisplayed"></b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Bắt buộc:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="selectedField.isRequired"></b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Điều kiện hiển thị:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-radio-group v-model="selectedField.displayConditionalType"
                                            :options="displayConditionalTypes"></b-form-radio-group>
                        <b-form inline v-if="selectedField.displayConditionalType == 1" class="display-conditional">
                            <b-col md="6">
                                <select2 v-model="selectedField.displayConditionalFieldName" :options="allCustomFields" placeholder="Tên trường"></select2>
                            </b-col>
                            <b-col md="2">
                                <select2 v-model="selectedField.displayConditionalOperator" :options="displayConditionalOperators" placeholder="Phép tính"></select2>
                            </b-col>
                            <b-col md="4">
                                <b-form-input v-model="selectedField.displayConditionalFieldValue" style="width: 100%" placeholder="Giá trị"></b-form-input>
                            </b-col>
                        </b-form>
                        <!--<div v-if="newField.displayConditionalType == 2">
                    <b-form-input v-model="newField.displayConditionalExpression" lazy></b-form-input>
                </div>-->
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal :no-enforce-focus="true" id="new-field-modal" ref="newFieldModal" size="lg" title="Thêm trường" @ok="saveNewField">
            <b-row>
                <b-col>
                    <b-form-group label="Tên trường dữ liệu:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <select2 v-model="newFieldSelected" :options="availableFields" style="width:100%"></select2>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Tên hiển thị:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-input v-model="newField.displayName" lazy></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Định dạng hiển thị:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-input v-model="newField.displayFormat" lazy></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Nhóm:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <select2 v-model="newField.groupId" :options="assetMutation.customGroups"></select2>
                        <!--<b-form-input v-model="newField.group" lazy></b-form-input>-->
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Hiển thị trên dòng mới:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="newField.displayNewLine"></b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Độ rộng grid:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-select v-model="newField.displayGridColumn" :options="gridColumnOptions"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Độ rộng label:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-select v-model="newField.displayLabelColumn" :options="gridColumnOptions"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="In đậm label:"
                                  :label-cols="8"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="newField.displayLabelBold"></b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="In nghiêng label:"
                                  :label-cols="8"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="newField.displayLabelItalic"></b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Không hiển thị label:"
                                  :label-cols="8"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="newField.displayLabelNone"></b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Hiển thị trên form tài sản:"
                                  :label-cols="8"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="newField.isDisplayed"></b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Bắt buộc:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-checkbox v-model="newField.isRequired"></b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Điều kiện hiển thị:"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-radio-group v-model="newField.displayConditionalType"
                                            :options="displayConditionalTypes"></b-form-radio-group>
                        <b-form inline v-if="newField.displayConditionalType == 1" class="display-conditional">
                            <b-col md="6">
                                <select2 v-model="newField.displayConditionalFieldName" :options="allCustomFields" placeholder="Tên trường"></select2>
                            </b-col>
                            <b-col md="2">
                                <select2 v-model="newField.displayConditionalOperator" :options="displayConditionalOperators" placeholder="Phép tính"></select2>
                            </b-col>
                            <b-col md="4">
                                <b-form-input v-model="newField.displayConditionalFieldValue" style="width: 100%" placeholder="Giá trị"></b-form-input>
                            </b-col>
                        </b-form>
                        <!--<div v-if="newField.displayConditionalType == 2">
                    <b-form-input v-model="newField.displayConditionalExpression" lazy></b-form-input>
                </div>-->
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>
    </div>

</template>
<script>
    import { mapState } from 'vuex'

    export default {
        name: 'AssetMutationMapping',
        components: {
        },
        data() {
            return {
                assetTypeGroupId: this.$route.query.assetTypeGroupId,
                assetMutationTypeId: this.$route.query.assetMutationTypeId,
                assetMutation: {
                },
                selectedField: {},
                newField: {},
                gridColumnOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                newGroupName: null,
                newGroupGridColumn: 12,
                selectedGroupName: null,
                selectedGroupGridColumn: null,
                selectedGroupNewGroupId: null,
                selectedGroup: {},
                allCustomFields: [],
                newFieldSelected: null,
                tempId: 0,
                dirty: false,
                displayConditionalOperators: [
                    { id: 1, text: '=' },
                    { id: 2, text: '!=' },
                    { id: 3, text: '>' },
                    { id: 4, text: '>=' },
                    { id: 5, text: '<' },
                    { id: 6, text: '<=' },
                    { id: 7, text: 'contain' },
                    { id: 8, text: 'not contain' }],
                displayConditionalTypes: [
                    { value: null, text: 'Luôn hiển thị' },
                    { value: 1, text: 'Theo điều kiện' },
                    //{ value: 2, text: 'Theo biểu thức' }
                ]
            }
        },
        computed: {
            ...mapState({
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
                assetMutationTypes: (state, getters) => state.common.assetMutationTypes
            }),
            customFieldGroups() {
                if (!this.assetMutation.customFields || this.assetMutation.customFields.length == 0) return [];

                var data = _(this.assetMutation.customFields).sortBy(field => field.groupId == undefined);
                var groupBy = _(data).groupBy(x => x.groupId).sortBy(group => data.indexOf(group[0])).value();
                var groups = [];

                for (var i = 0; i < groupBy.length; i++) {
                    groups.push({ ref: (this.assetMutation.customGroups || []).find(x => x.id == groupBy[i][0].groupId) || { text: 'undefined' }, fields: groupBy[i] });
                }

                return groups;
            },
            availableFields() {
                return this.allCustomFields;
                //var currentFields = this.assetMutation.customFields || [];

                //return this.allCustomFields.filter(x => {
                //    return currentFields.find(y => y.name == x.id) == null;
                //})
            }
        },
        created() {
            this.loadAllCustomFields();
            this.loadAssetMutationSample();
        },
        methods: {
            loadAllCustomFields() {
                var vm = this;
                this.$services.get('field-mapping/fields').done((response) => {
                    vm.allCustomFields = response.map(x => {
                        return {
                            id: x.name,
                            text: x.displayName,
                            format: x.displayFormat
                        };
                    });
                });
            },
            loadAssetMutationSample() {
                if (this.assetTypeGroupId && this.assetMutationTypeId) {
                    if (!this.dirty || confirm('Thay đổi mapping chưa được cập nhật. Bạn có chắc muốn load lại dữ liệu?')) {
                        var vm = this;
                        return this.$services.get(`field-mapping/mapping/${this.assetTypeGroupId}/${this.assetMutationTypeId}/sample`).done(assetMutation => {
                            for (var i = 0; i < assetMutation.customFields.length; i++) {
                                if (assetMutation.customFields[i].groupId) {
                                    assetMutation.customFields[i].group = assetMutation.customGroups.find(x => x.id == assetMutation.customFields[i].groupId);
                                }
                            }
                            vm.assetMutation = assetMutation;
                            scrollToTop();
                            vm.dirty = false;
                        });
                    }
                }
            },
            getLabelClass(field) {
                var classes = '';

                if (field.isRequired) {
                    classes += ' required';
                }

                if (field.displayLabelBold) {
                    classes += ' label-bold';
                }

                if (field.displayLabelItalic) {
                    classes += ' label-italic';
                }

                if (field.displayLabelNone) {
                    classes += ' label-none';
                }

                return classes;
            },
            getFieldLabel(field) {
                var index = field.displayName.indexOf('.');
                return index == - 1 ? field.displayName : field.displayName.substr(0, index);
            },
            getFieldTitle(field) {
                return field.name;
                //var index = field.displayName.indexOf('.');
                //return index == - 1 ? null : field.displayName.substr(index);
            },
            getFieldValue(field) {
                if (field.format != null) {
                    return field.format;
                } else if (field.lookupValue != null) {
                    return field.lookupValue;
                }

                return field.value;
            },
            addNewField(prevField, offset) {
                if (prevField && prevField.id) {
                    this.newField = {
                        id: --this.tempId,
                        name: '',
                        displayName: '',
                        displayFormat: null,
                        value: '',
                        lookupValue: '',
                        groupId: prevField.groupId,
                        group: prevField.group,
                        order: prevField.order + offset,
                        displayNewLine: false,
                        displayGridColumn: 6,
                        displayLabelColumn: 4,
                        displayLabelBold: false,
                        displayLabelItalic: false,
                        displayLabelNone: false,
                        isDisplayed: true,
                        isRequired: false,
                        displayConditionalType: null,
                        displayConditionalFieldName: '',
                        displayConditionalOperator: null,
                        displayConditionalFieldValue: '',
                        //displayConditionalExpression: '',

                        index: this.assetMutation.customFields.indexOf(prevField) + offset
                    };
                } else {
                    this.newField = {
                        id: --this.tempId,
                        name: '',
                        displayName: '',
                        displayFormat: null,
                        value: '',
                        lookupValue: '',
                        groupId: null,
                        group: null,
                        order: 0,
                        displayNewLine: false,
                        displayGridColumn: 6,
                        displayLabelColumn: 4,
                        displayLabelBold: false,
                        displayLabelItalic: false,
                        displayLabelItalic: false,
                        isDisplayed: true,
                        isRequired: false,
                        displayConditionalType: null,
                        displayConditionalFieldName: '',
                        displayConditionalOperator: null,
                        displayConditionalFieldValue: '',
                        //displayConditionalExpression: '',

                        index: this.assetMutation.customFields.length + 1
                    };
                }

                var vm = this;
                this.$refs.newFieldModal.show();

                setTimeout(function () {
                    vm.$refs.newFieldModal.getActiveElement().removeAttribute('tabindex');
                }, 1000);
            },
            saveNewField() {
                this.newField.group = this.assetMutation.customGroups.find(x => x.id == this.newField.groupId);
                var fields = this.assetMutation.customFields;
                fields.splice(this.newField.index, 0, this.newField);

                this.assetMutation.customFields = fields;
                this.dirty = true;
            },
            edit(field) {
                this.selectedField = {
                    id: field.id,
                    name: field.name,
                    displayName: field.displayName,
                    displayFormat: field.displayFormat,
                    value: field.value,
                    lookupValue: field.lookupValue,
                    groupId: field.groupId,
                    group: field.group,
                    format: field.format,
                    order: field.order,
                    displayNewLine: field.displayNewLine,
                    displayGridColumn: field.displayGridColumn,
                    displayLabelColumn: field.displayLabelColumn,
                    displayLabelBold: field.displayLabelBold,
                    displayLabelItalic: field.displayLabelItalic,
                    displayLabelNone: field.displayLabelNone,
                    isDisplayed: field.isDisplayed,
                    isRequired: field.isRequired,
                    displayConditionalType: field.displayConditionalType,
                    displayConditionalFieldName: field.displayConditionalFieldName,
                    displayConditionalOperator: field.displayConditionalOperator,
                    displayConditionalFieldValue: field.displayConditionalFieldValue,
                    //displayConditionalExpression: field.displayConditionalExpression
                };

                this.$refs.fieldEditModal.show();
            },
            save() {
                var field = this.assetMutation.customFields.find(x => x.id == this.selectedField.id);
                if (field) {
                    field.displayName = this.selectedField.displayName;
                    field.displayFormat = this.selectedField.displayFormat;
                    field.groupId = this.selectedField.groupId;
                    field.group = this.assetMutation.customGroups.find(x => x.id == this.selectedField.groupId);
                    field.format = this.selectedField.format;
                    field.order = this.selectedField.order;
                    field.displayNewLine = this.selectedField.displayNewLine;
                    field.displayGridColumn = this.selectedField.displayGridColumn;
                    field.displayLabelColumn = this.selectedField.displayLabelColumn;
                    field.displayLabelBold = this.selectedField.displayLabelBold;
                    field.displayLabelItalic = this.selectedField.displayLabelItalic;
                    field.displayLabelNone = this.selectedField.displayLabelNone;
                    field.isDisplayed = this.selectedField.isDisplayed;
                    field.isRequired = this.selectedField.isRequired;
                    field.displayConditionalType = this.selectedField.displayConditionalType;
                    field.displayConditionalFieldName = this.selectedField.displayConditionalFieldName;
                    field.displayConditionalOperator = this.selectedField.displayConditionalOperator;
                    field.displayConditionalFieldValue = this.selectedField.displayConditionalFieldValue;
                    //field.displayConditionalExpression = this.selectedField.displayConditionalExpression;
                    this.dirty = true;
                }
            },
            remove(field) {
                if (confirm('Bạn có chắc muốn xóa trường mapping này?')) {
                    this.assetMutation.customFields.remove(field);
                    this.dirty = true;
                }
            },
            swap(field1, field2) {
                var index1 = this.assetMutation.customFields.indexOf(field1);
                var index2 = this.assetMutation.customFields.indexOf(field2);

                var order = field1.order;
                field1.order = field2.order;
                field2.order = order;

                this.$root.$set(this.assetMutation.customFields, index1, field2);
                this.$root.$set(this.assetMutation.customFields, index2, field1);
                this.dirty = true;
            },
            addNewGroup(group) {
                this.newGroupName = '';
                this.newGroupGridColumn = 12;

                this.$refs.groupAddNewModal.show();
            },
            saveNewGroup() {
                this.assetMutation.customGroups.push({
                    id: --this.tempId,
                    text: this.newGroupName,
                    displayGridColumn: this.newGroupGridColumn
                });
                this.dirty = true;
            },
            editGroup(group) {
                this.selectedGroup = group.ref;
                this.selectedGroupName = group.ref.text;
                this.selectedGroupGridColumn = group.ref.displayGridColumn;

                this.$refs.groupEditModal.show();
            },
            saveEditedGroup() {
                if (this.selectedGroup.id) {
                    this.selectedGroup.text = this.selectedGroupName;
                    this.selectedGroup.displayGridColumn = this.selectedGroupGridColumn;
                } else if (this.selectedGroupNewGroupId) {
                    var fields = this.assetMutation.customFields.filter(x => x.groupId == null);
                    var group = this.assetMutation.customGroups.find(x => x.id == this.selectedGroupNewGroupId);
                    for (var i = 0; i < fields.length; i++) {
                        fields[i].groupId = this.selectedGroupNewGroupId;
                        fields[i].group = group;
                    }
                }
                this.dirty = true;
            },
            removeGroup(group) {
                if (confirm('Bạn có chắc muốn xóa nhóm mapping này?')) {
                    var fields = group.fields;
                    for (var i = 0; i < fields.length; i++) {
                        this.assetMutation.customFields.remove(fields[i]);
                    }
                    this.assetMutation.customGroups.remove(group.ref);
                    this.dirty = true;
                }
            },
            swapGroup(group1, group2) {
                var groups = this.customFieldGroups

                var index1 = groups.indexOf(group1);
                var index2 = groups.indexOf(group2);

                groups[index1] = group2;
                groups[index2] = group1;

                var ref1 = this.assetMutation.customGroups.indexOf(group1.ref);
                var ref2 = this.assetMutation.customGroups.indexOf(group2.ref);

                this.assetMutation.customGroups[ref1] = group2.ref;
                this.assetMutation.customGroups[ref2] = group1.ref;

                this.assetMutation.customFields = groups.map(x => x.fields).reduce((x, y) => x.concat(y));
                this.dirty = true;
            },
            displayGroup(checked, group) {
                for (var i = 0; i < group.fields.length; i++) {
                    group.fields[i].isDisplayed = checked;
                }
            },
            saveMappings() {
                var vm = this;
                //var fieldMappings = this.assetMutation.customFields.map(item => {
                //    return {
                //        assetTypeGroupId: this.assetTypeGroupId,
                //        assetMutationTypeId: this.assetMutationTypeId,
                //        fieldName: item.name,
                //        displayName: item.displayName,
                //        isRequired: item.isRequired,
                //        isDisplayed: true,
                //        displayGroup: item.group,
                //        displayNewLine: item.displayNewLine,
                //        displayGridColumn: item.displayGridColumn,
                //        displayLabelColumn: item.displayLabelColumn,
                //    };
                //});
                this.$services.put(`field-mapping/mapping/${this.assetTypeGroupId}/${this.assetMutationTypeId}/save-form`, this.assetMutation.customFields).done(() => {
                    vm.$toastr.s('Cập nhật giao diện Form hiển thị thành công');
                    vm.dirty = false;
                });
            }
        },
        watch: {
            newFieldSelected(val) {
                if (val) {
                    this.newField.name = val;
                    var field = this.availableFields.find(x => x.id == val);
                    this.newField.displayName = field.text;
                    this.newField.displayFormat = field.format;
                }
            }
        }
    }
</script>
<style scoped>

    label {
        font-weight: 400;
        font-style: italic;
    }

    .text-1 {
        font-weight: 500;
    }

    .card {
        margin-bottom: 0;
        margin-top: 1.5rem;
        border: none;
    }

    .editable:hover {
        border: 1px solid red;
    }

    span.select2-container {
        z-index: 1005000;
    }

    .display-conditional div {
        padding-left: 0px;
        padding-right: 5px;
    }
</style>
